import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {GoogleAnalyticsEventModel} from "../../../third-party-services/analytics/google-analytics/google-analytics-event-model";
import {APP} from "../../../core/app/consts";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class NavigationTabModuleTabClickEvent extends ClickEvent {
  entityType: String;
  entityId: Number;
  tabName: String;
  status: ANALYTICS.GAME_STATUSES;

  constructor(params) {
    super('', 'click', 'navigation-tabs');

    this.entityType = params.entityType;
    this.entityId = params.entityId;
    this.tabName = params.tabName;
    this.status = params.status;
  }

  get properties() {
    const properties = super.properties;

    properties.entityType = this.entityType;
    properties.entityId = this.entityId;
    properties.tabName = this.tabName;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];

    return properties;
  }

  get googleAnalyticsEvent(): GoogleAnalyticsEventModel {
    const eventName = this.resolveEventName();

    return new GoogleAnalyticsEventModel(eventName, {
      properties: {
        entityId: this.entityId,
        entity_type: APP.GOOGLE_ANALYTICS.ENTITY_TYPES[this.entityType],
        tab_name: this.tabName,
        status: ANALYTICS.GAME_STATUSES[this.status]
      }
    })
  }
}